namespace nscs.screen.stories {

    export class AnimationStory_4_1 extends Phaser.GameObjects.Container {

        frame = {name:'AnimationStory_4_1'};

        _bg:Phaser.GameObjects.Image;
        story_2_1_2:Phaser.GameObjects.Image;
        story_2_1_1:Phaser.GameObjects.Image;

        constructor(scene:Phaser.Scene) {
            super(scene);


            this._bg = this.scene.add.image(-100, -100, 'bg-atlas', 'bg3' + '0000');
            this._bg.setOrigin(0, 0);

            this.story_2_1_2 = this.scene.add.image(250, 0, 'stories', 'story_4_1_2' + '0000');
            this.story_2_1_2.setOrigin(0, 0);

            this.story_2_1_1 = this.scene.add.image(350, 272, 'stories', 'story_2_1_1' + '0000');
            this.story_2_1_1.setOrigin(0.5, 1);

            this.add([this._bg, this.story_2_1_2, this.story_2_1_1]);

            this.scene.tweens.add({
                targets: this._bg,
                duration: 3000,
                x: this._bg.x-50,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.story_2_1_2,
                duration: 2500,
                x: this.story_2_1_2.x - 135,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: this.story_2_1_1,
                duration: 3000,
                x: this.story_2_1_1.x - 200,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            let r = new Phaser.GameObjects.Graphics(this.scene);
            r.setPosition(0, 242);
            r.fillStyle(0x0, 1);
            r.fillRect(0, 0, game.scale.width, 200);
            this.add(r);
        }
    }
}